/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import {
  getAdobeSiteSection,
  MenuItem,
  Menu,
} from '@cigna/cigna-for-brokers/shared/util';
import { MatMenuTrigger } from '@angular/material/menu';
import isEmpty from 'lodash/isEmpty';
import {
  SubMenuNavService,
  Roles,
  ValidationResponse,
} from '../+state/sub-menu-nav.service';
import { SelectProducerCodeComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { MatDialog } from '@angular/material/dialog';
import {
  AppstateFacade,
  Entitlement,
  NavigationResponse,
  Role,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { takeUntil, take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import {
  NavigationStart,
  Router,
  Event as NavigationEvent,
} from '@angular/router';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { ProfileType } from '@cigna/cigna-for-brokers/shared/data-access';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'cigna-brk-nav-item-sub-menu',
  templateUrl: './nav-item-sub-menu.component.html',
  styleUrls: ['./nav-item-sub-menu.component.scss'],
})
export class NavItemSubMenuComponent implements OnInit, OnDestroy {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  @Input() item: MenuItem;
  @Input() parentItem: MenuItem;
  @Input() idx: string;
  @Input() isImpersonatorFlag: boolean;
  @Input() hasIfpAdminMenu: boolean;

  @Output() itemClicked = new EventEmitter<{
    parentItem: string;
    item: MenuItem;
    disableTracking?: boolean;
  }>();
  isSubMenuVisible: boolean;
  subMenuClickSubscription: Subscription;
  selectedItem: string;
  linkName: string;
  apiUrl: string;
  toolsUrl: string;
  urlTarget: string;
  hasMedicalExtAgency: boolean;
  profileData$ = this._appstateFacade.isProfileUser$;
  navigation$ = this._appstateFacade.navigation$;
  roles$ = this._appstateFacade.roles$;
  dataRes: string[];
  roles: Roles[] = [];
  csbRoles: Roles[] = [];
  filteredRoles: Roles[] = [];
  hasMedicalExtAgent: boolean;
  hasMedicalIntAdmin: boolean;
  urlLinkName: string;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  hasQaEIFPMedicalExtAgency$ = this._appstateFacade.hasOneOfEntitlements$([
    Entitlement.QaEIFPMedicalExtAgency,
  ]);
  hasQaEIFPMedicalExtAgent$ = this._appstateFacade.hasOneOfEntitlements$([
    Entitlement.QaEIFPMedicalExtAgent,
  ]);
  hasQaEIFPMedicalIntAdmin$ = this._appstateFacade.hasOneOfEntitlements$([
    Entitlement.QaEIFPMedicalIntAdmin,
  ]);

  errorMessage: string | undefined;
  getFirstName: string | undefined;
  getLastName: string | undefined;
  getEmail: string | undefined;
  getNavigationsData: NavigationResponse;
  adobeParentNav: string;
  currentURL: string;
  currentURLSubscription: Subscription;
  isMedicareMedicaidLookupToggleOn: boolean;
  isMedicareMedicaidLookupEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isMedicareMedicaidLookupEnabled',
  ]);
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);
  did0621ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'did0621ChangesEnabled',
  ]);
  did0228ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'did0228ChangesEnabled',
  ]);
  didTraining0214ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'didTraining0214ChangesEnabled',
  ]);
  did0621ChangesEnabled: boolean;
  did0228ChangesEnabled: boolean;
  didTraining0214ChangesEnabled: boolean;
  maLobRoleItem: Role;
  navItem: string;
  csbRoleId = '';
  csbBrokerId = '';

  constructor(
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private subMenuNavService: SubMenuNavService,
    public _appstateFacade: AppstateFacade,
    public analytics: ShellTrackHandlers,
    public router: Router,
    private featureTogglesFacade: FeatureTogglesFacade,
    private _gw: AppStateGateway,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.currentURL = this.router.url;
    this.currentURLSubscription = this.router.events.subscribe(
      (event: NavigationEvent) => {
        if (event instanceof NavigationStart) {
          this.currentURL = event.url;
        }
      },
    );
    this.subMenuClickSubscription =
      this.subMenuNavService.subMenuClickedSubject.subscribe((subMenuItem) => {
        if (subMenuItem && this.item.text !== subMenuItem && this.trigger) {
          this.isSubMenuVisible = false;
          this.trigger.closeMenu();
        }
      });

    this.hasQaEIFPMedicalExtAgency$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((hasIfpMedicalExtAgency) => {
        this.hasMedicalExtAgency = hasIfpMedicalExtAgency;
      });

    this.hasQaEIFPMedicalIntAdmin$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((hasIfpMedicalIntAdmin) => {
        this.hasMedicalIntAdmin = hasIfpMedicalIntAdmin;
      });

    this.roles$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((resroles) => {
      this.setRoles(resroles);
    });

    // role check
    this.filteredRoles = [];

    if (this.roles.length === 1) {
      this.roles.forEach((roleitem) => {
        this.filteredRoles.push(roleitem);
      });
    }

    this.hasQaEIFPMedicalExtAgent$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((hasIfpMedicalExtAgent) => {
        this.hasMedicalExtAgent = hasIfpMedicalExtAgent;
      });

    this.navigation$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: NavigationResponse) => {
        this.getNavigationsData = res;
      });

    this.profileData$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: any) => {
        if (res) {
          const obj = res.accessTokenBody['cigna.producerCodes'];
          const pcodeData = obj.split(' ');
          const ar: string[] = [];
          pcodeData.forEach((x: string) => {
            const pcode = x.split('-');
            if (pcode[0] === 'IFP') {
              ar.push(pcode[1]);
            }
          });
          this.dataRes = ar;
        }
      });
    this.isMedicareMedicaidLookupEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isMedicareMedicaidLookupEnabled) => {
        this.isMedicareMedicaidLookupToggleOn = isMedicareMedicaidLookupEnabled;
      });

    this.did0621ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.did0621ChangesEnabled = isFeatureToggleEnabled;
      });

    this.did0228ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.did0228ChangesEnabled = isFeatureToggleEnabled;
      });

    this.didTraining0214ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.didTraining0214ChangesEnabled = isFeatureToggleEnabled;
      });
  }

  setRoles(resroles: Role[] | undefined) {
    if (resroles) {
      resroles.forEach((roleitem) => {
        if (roleitem.lob === 'IFP') {
          const isRoleExist = this.roles.some(
            (role) => role.producerCode === roleitem.producerCode,
          );
          if (!isRoleExist) {
            this.roles.push(roleitem);
          }
        } else if (roleitem.lob === 'CSB') {
          const isCsbRoleExist = this.csbRoles.some(
            (role) => role.producerCode === roleitem.producerCode,
          );
          if (!isCsbRoleExist) {
            this.csbRoles.push(roleitem);
          }
        } else if (roleitem.lob === 'MA') {
          this.maLobRoleItem = roleitem;
        }
      });
    }
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('spcode');
    if (this.subMenuClickSubscription) {
      this.subMenuClickSubscription.unsubscribe();
    }
    if (this.currentURLSubscription) {
      this.currentURLSubscription.unsubscribe();
    }
  }

  navItemSubMenuClicked(event: any) {
    this.adobeParentNav = this.parentItem.text;
    if (isEmpty(this.item?.submenu)) {
      if (
        !this.isImpersonatorFlag ||
        (this.isImpersonatorFlag &&
          (this.item.entitlement === 'smenu-com-compensation' ||
            this.item.entitlement === 'smenu-ma-compensation' ||
            this.item.entitlement === 'smenu-com-book-business' ||
            this.item.entitlement === 'smenu-com-req-proposal' ||
            this.item.entitlement === 'smenu-com-training' ||
            this.item.entitlement === 'smenu-com-solutions-insights' ||
            this.item.entitlement === 'smenu-csb-incentives' ||
            this.item.entitlement === 'smenu-sgp-renewals' ||
            this.item.entitlement === 'smenu-com-funding-solutions'))
      ) {
        this.emitItemClick(
          this.parentItem.text,
          this.item,
          this.item.entitlement,
        );
      }
    } else {
      this.isSubMenuVisible = !this.isSubMenuVisible;
      if (this.isSubMenuVisible) {
        this.trigger.openMenu();
      } else {
        this.trigger.closeMenu();
      }

      this.subMenuNavService.publishSubMenuCLicked(this.item.text);
      event.stopPropagation();
    }
  }

  emitItemClick(
    parentItem: string,
    item: MenuItem,
    entitlement: string | string[] | undefined,
  ) {
    const shouldCheckCbSession =
      (this.didTraining0214ChangesEnabled &&
        entitlement === 'smenu-csb-training') ||
      (this.did0228ChangesEnabled &&
        entitlement === 'smenu-csb-sale-marketing');
    const role76 = this.csbRoles.find((x) => x.roleId === '76');
    const role78 = this.csbRoles.find((x) => x.roleId === '78');

    if (role76) {
      this.csbRoleId = role76?.roleId!;
      this.csbBrokerId = role76?.brokerId!;
    } else {
      this.csbRoleId = role78?.roleId!;
      this.csbBrokerId = role78?.brokerId!;
    }

    if (shouldCheckCbSession && (role76 || role78)) {
      this.subMenuNavService
        .getUserSession(this.csbRoleId, this.csbBrokerId)
        ?.subscribe(
          (response) => {
            if (response.metadata?.outcome?.status === 200) {
              this.itemClicked.emit({
                parentItem,
                item,
              });
            } else {
              window.confirm(
                response.metadata?.outcome?.message ??
                  'You are not authorized to access this request.',
              );
            }
          },
          (error: HttpErrorResponse) => {
            window.confirm('You are not authorized to access this request.');
          },
        );
    } else {
      this.itemClicked.emit({
        parentItem,
        item,
      });
    }
  }

  navItemSubSubMenuClicked(sItem: MenuItem) {
    if (sItem.isTool) {
      this.navItem = 'Tools';
    } else if (
      sItem.entitlement === 'l3menu-csb-my-customers' ||
      sItem.entitlement === 'l3menu-csb-policy-report' ||
      sItem.entitlement === 'l3menu-csb-agent-inquiry'
    ) {
      this.navItem = 'Reporting';
    } else if (
      sItem.entitlement === 'l3menu-csb-product-info' ||
      sItem.entitlement === 'l3menu-csb-business-building' ||
      sItem.entitlement === 'l3menu-csb-benefits' ||
      sItem.entitlement === 'l3menu-csb-servicing-forms'
    ) {
      this.navItem = 'Resource Center';
    } else {
      this.navItem = 'Quote and Enroll';
    }
    if (!this.isImpersonatorFlag) {
      const adobeSection = getAdobeSiteSection(this.router.url);
      this.analytics.trackEventOther({}, sItem.text, 'ac24437', {
        eVar119: 'MTD-1458',
        eVar120: 'left-main-nav',
        prop67: 'action',
        channel: adobeSection.channel,
        pageName: adobeSection.pageName,
        prop20: `${this.adobeParentNav} - ${this.navItem}`,
      });
    }
    if (
      !this.isImpersonatorFlag ||
      (this.isImpersonatorFlag &&
        (sItem.text === 'Medicare/Medicaid Eligibility' ||
          (this.did0621ChangesEnabled &&
            (sItem.text === 'Find a Doctor or Dentist' ||
              sItem.text === 'Find RX Medications' ||
              sItem.text === 'Cigna.com' ||
              sItem.text === 'Provider Directory' ||
              sItem.text === 'Prescription Drug List' ||
              sItem.text === 'Cigna for Employers' ||
              sItem.text === 'Online Provider Directory' ||
              sItem.text === 'Find RX Medications 2023' ||
              sItem.text === 'Medicare Plan Finder' ||
              sItem.text === 'Marketing Review Submission' ||
              sItem.text === 'Cigna Learning Center' ||
              sItem.text === 'Find RX Medications 2024' ||
              sItem.text === 'Find RX Medications 2025' ||
              sItem.text === 'YouTube'))))
    ) {
      this.setActiveNavMenu(this.parentItem?.text);
      this.selectedItem = sItem.text;
      if (
        (sItem.text === 'Medical' || sItem.text === 'Dental') &&
        !sItem.isTool
      ) {
        if (sItem.text === 'Medical') {
          this.linkName = 'broker.quoteEnroll.medical';
        } else {
          this.linkName = sItem.text;
        }

        if (
          this.linkName === 'broker.quoteEnroll.medical' &&
          (this.hasMedicalExtAgency || this.hasMedicalIntAdmin)
        ) {
          this.getIfpMedicalAgency();
        } else if (sItem.text === 'Dental') {
          this.getBrokerQuoteDental();
        } else {
          this.producerCodesDialog(this.linkName, sItem);
        }
      } else if (sItem.isTool) {
        if (sItem.isExternal === false) {
          this.toolsUrl = `${window.location.origin}${sItem.route}`;
          this.urlTarget = '_self';
        } else {
          this.toolsUrl = `${sItem.route}`;
          this.urlTarget = '_blank';
        }

        if (
          sItem.text === 'View License & Appointment Information' ||
          sItem.text === 'View Documents and Forms' ||
          sItem.text === 'View and Update Producer Information'
        ) {
          // eslint-disable-next-line no-unused-expressions
          this.apiUrl = `${this.toolsUrl}`;

          if (sItem.text === 'View License & Appointment Information') {
            sItem.entitlement = 'l3menu-ind-tools-license';
          } else if (sItem.text === 'View Documents and Forms') {
            sItem.entitlement = 'l3menu-ind-tools-doc-forms';
          } else if (sItem.text === 'View and Update Producer Information') {
            sItem.entitlement = 'l3menu-ind-tools-producer-info';
          }

          this.producerCodesDialog(sItem.text, sItem);
        } else {
          this.goToToolsUrl(sItem);
        }
      } else if (
        sItem.text === 'MA 2022' &&
        (sItem.entitlement?.includes('l3menu-ind-med-health-sherp-ext') ||
          sItem.entitlement?.includes('l3menu-ind-med-sherp-ext-agent') ||
          sItem.entitlement?.includes('l3menu-ind-med-sherp-ext-agency'))
      ) {
        this.getBrokerQuoteAdvantage2022();
      } else if (
        sItem.text === 'MA 2023' &&
        sItem.entitlement === 'l3menu-ind-dental-express'
      ) {
        this.getBrokerQuoteAdvantage2023();
      } else {
        this.itemClicked.emit({
          parentItem: this.parentItem.text,
          item: sItem,
          disableTracking: true,
        });
      }
    }
  }

  goToURL(urlLinkName: string): void {
    if (urlLinkName === 'broker.quoteEnroll.medical') {
      this.getBrokerQuoteMedical();
    } else if (urlLinkName === 'broker.quoteEnroll.medicalextagt') {
      this.getUserSession();
    } else if (urlLinkName === 'broker.bookOfBusiness.plans') {
      this.getBrokerBobPlans();
    } else if (
      urlLinkName === 'View License & Appointment Information' ||
      urlLinkName === 'View Documents and Forms' ||
      urlLinkName === 'View and Update Producer Information'
    ) {
      this.redirectToToolsUrl();
    }
  }

  getBrokerQuoteMedical(): void {
    // Delay added to get the adobe call to complete
    setTimeout(() => {
      this.subMenuNavService.getBrokerQuoteMedical(
        this.filteredRoles[0]?.roleId,
        this.filteredRoles[0]?.brokerId,
      );
    }, 1500);
  }
  getIfpMedicalAgency(): void {
    // Delay added to get the adobe call to complete
    setTimeout(() => {
      this.subMenuNavService.getIfpMedicalAgency();
    }, 1500);
  }
  getBrokerQuoteDental(): void {
    // Delay added to get the adobe call to complete
    setTimeout(() => {
      this.subMenuNavService.getBrokerQuoteDental();
    }, 1500);
  }
  getBrokerBobPlans(): void {
    // Delay added to get the adobe call to complete
    setTimeout(() => {
      this.subMenuNavService.getBrokerBobPlans(
        this.filteredRoles[0]?.roleId,
        this.filteredRoles[0]?.brokerId,
      );
    }, 1500);
  }
  getBrokerQuoteAdvantage2022(): void {
    this.subMenuNavService.getBrokerQuoteAdvantage2022();
  }
  getBrokerQuoteAdvantage2023(): void {
    this.subMenuNavService.getBrokerQuoteAdvantage2023();
  }
  redirectToToolsUrl(): void {
    this.apiUrl = `${this.toolsUrl}?roleId=${this.filteredRoles[0]?.roleId}&brokerId=${this.filteredRoles[0]?.brokerId}`;
    setTimeout(() => {
      window.open(this.apiUrl, this.urlTarget);
    }, 1500);
  }
  goToToolsUrl(sItem: MenuItem): void {
    if (
      this.toolsUrl.includes('medicare-medicaid-eligibility') &&
      this.isMedicareMedicaidLookupToggleOn
    ) {
      this.router.navigate(['/secure/medicare-medicaid-eligibility']);
    } else {
      const maItems = [
        'salesforce',
        'custompoint',
        'connecture drx',
        'medicare producer',
      ];
      const toolsLinkText = sItem.text.toLowerCase();
      if (
        this.maLobRoleItem &&
        this.maLobRoleItem.lob === 'MA' &&
        maItems.some((i) => toolsLinkText.startsWith(i))
      ) {
        this.checkMaSession(this.maLobRoleItem);
      }
      setTimeout(() => {
        this.redirectToExtUrl(this.toolsUrl, this.urlTarget);
      }, 1500);
    }
  }

  redirectToExtUrl(extUrl: string, target: string) {
    this.isOktaLoginEnabled$
      .pipe(take(1))
      .subscribe((isOktaLoginEnabled: boolean) => {
        const isOktaExtRedirectUrl = this.translate.instant(
          `global.isOktaExtRedirectUrl`,
        );
        if (isOktaLoginEnabled && isOktaExtRedirectUrl === 'true') {
          const oktaExtRedirect = this._gw.getOktaExtRedirect(extUrl);
          window.open(oktaExtRedirect, target);
        } else {
          window.open(extUrl, target);
        }
      });
  }

  producerCodesDialog(linkName: string, item?: MenuItem): void {
    this.urlLinkName =
      linkName === 'broker.quoteEnroll.medical' && this.hasMedicalExtAgent
        ? 'broker.quoteEnroll.medicalextagt'
        : linkName;

    if (linkName === 'broker.quoteEnroll.medical' && this.hasMedicalExtAgency) {
      this.getIfpMedicalAgency();
    } else {
      // role check
      this.filteredRoles = [];
      if (Array.isArray(item?.entitlement)) {
        item?.entitlement?.forEach((ent) => {
          this.roles.forEach((roleitem) => {
            const isExist = roleitem.entitlements?.some(
              (check: string) => check === ent,
            );
            if (isExist) {
              const isRoleExist = this.filteredRoles.some(
                (role) => role.producerCode === roleitem.producerCode,
              );
              if (!isRoleExist) {
                this.filteredRoles.push(roleitem);
              }
            }
          });
        });
      } else {
        this.roles.forEach((roleitem) => {
          const isExist = roleitem.entitlements?.some(
            (check: string) => check === item?.entitlement,
          );
          if (isExist) {
            const isRoleExist = this.filteredRoles.some(
              (role) => role.producerCode === roleitem.producerCode,
            );
            if (!isRoleExist) {
              this.filteredRoles.push(roleitem);
            }
          }
        });
      }

      if (this.filteredRoles.length === 1) {
        // Delay added to get the adobe call to complete
        setTimeout(() => {
          this.goToURL(this.urlLinkName);
        }, 1500);
      } else if (this.filteredRoles.length >= 1) {
        this.dialog.open(SelectProducerCodeComponent, {
          width: '670px',
          data: {
            urllink: this.urlLinkName,
            toolsurl: this.apiUrl ?? '',
            data: this.dataRes,
            rolesdata: this.filteredRoles,
            navdata: this.getNavigationsData,
            hasIfpAdminMenuFlag: this.hasIfpAdminMenu,
          },
          autoFocus: false,
        });
      }
    }
  }

  getUserSession(): void {
    this.subMenuNavService
      .getUserSession(
        this.filteredRoles[0]?.roleId,
        this.filteredRoles[0]?.brokerId,
      )
      ?.subscribe(
        (response) => {
          this.onGetUserSessionSuccess(response);
        },
        (error: HttpErrorResponse) => {
          window.confirm('You are not authorized to access this request.');
        },
      );
  }

  onGetUserSessionSuccess(response: ValidationResponse) {
    if (response.metadata?.outcome?.status === 200) {
      this.getIfpMedicalExtAgent();
    } else {
      window.confirm(response.metadata?.outcome?.message);
    }
  }

  checkMaSession(roleitem: Role): void {
    this.subMenuNavService
      .getUserSession(roleitem.roleId, roleitem.brokerId)
      ?.subscribe(
        () => {},
        (error: HttpErrorResponse) => {},
      );
  }
  getIfpMedicalExtAgent(): void {
    this.subMenuNavService.getIfpMedicalExtAgent();
  }

  setActiveNavMenu(navMenuText: string) {
    localStorage.setItem('activeNavMenu', navMenuText);
  }

  @HostListener('document:click', ['$event'])
  clickedOut(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isSubMenuVisible = false;
    }
  }
}
